import { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'
import { fonts, fontWeights, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const menu: CSSObject = {
  minInlineSize: 210,
}

export const menuItem: CSSObject = {
  fontWeight: fontWeights.bolder,
  fontFamily: fonts.sansSerif,
  fontSize: fontSizes.xSmall,
  minBlockSize: Spacing.M * 1.5,
  color: 'inherit !important',
}

export const triggerButton: CSSObject = {
  color: colors.n5.base,

  '&:hover': {
    backgroundColor: colors.n5.base,
    color: '#fff',
  },
  '&[aria-pressed="true"]': {
    backgroundColor: colors.n3.base,
    color: '#fff',
  },
}
